import Vue from 'vue'

export default {
  getMarkerLayerEmitterCategories({ getters, commit }) {
    return Vue.http
      .get(getters.endpoint.categoryList, {
        params: {
          [getters.objectsPeriod.scaleType.id]: getters.objectsPeriod.borders.join(','),
          workspace: getters.workspace,
          version: getters.version,
          limit: 1000
        }
      })
      .then((r) => {
        commit('setMarkerLayersEmitterCategories', r.data.results)
      })
  },

  getMarkerLayerEmitter({ getters, commit, dispatch }, id) {
    return Vue.http
      .get(getters.endpoint.emitterById(id), {
        params: {
          [getters.objectsPeriod.scaleType.id]: getters.objectsPeriod.borders.join(','),
          workspace: getters.workspace,
          version: getters.version
        }
      })
      .then((r) => {
        if (r.data) {
          const results = r.data
          if (results.building) {
            results.building = {
              ...results.building,
              name: results.building.address
            }
          }
          commit('setMarkerLayersEmitter', r.data)
          let buildings = []
          if (results.building) {
            buildings = [
              {
                isEditable: false,
                type: 'building',
                name: results.building.name || 'Здание ' + results.building.id,
                coordinates: results.building.point.coordinates.concat([]).reverse()
              }
            ]
          }
          results.container_platforms = results.container_platforms
            ? results.container_platforms.map((v) => {
                return {
                  ...v,
                  name: v.name || v.address || 'Контейнерная площадка ' + v.id
                }
              })
            : []
          const containerplatforms = results.container_platforms.map((v) => {
            return {
              isEditable: false,
              type: 'containerplatform',
              name: v.name,
              coordinates: v.point && v.point.coordinates
            }
          })
          if (getters.markerLayersToEdit.type === 'emitter') {
            commit('updateMarkerLayersMap', {
              buildings,
              containerplatforms
            })
          }
        }
      })
  },

  getMarkerLayerContainerPlatform({ getters, commit, dispatch }, id) {
    return Vue.http
      .get(getters.endpoint.containerplatformById(id), {
        params: {
          [getters.objectsPeriod.scaleType.id]: getters.objectsPeriod.borders.join(','),
          workspace: getters.workspace,
          version: getters.version
        }
      })
      .then((r) => {
        const containersMap = getters.objectContainerTypes
        if (r.data) {
          const results = r.data
          results.containers = results.containers || []
          results.containers = results.containers.map((v) => {
            return {
              ...v,
              name:
                'Контейнер ' +
                v.id +
                ' (' +
                v.volume_representation +
                '; ' +
                (containersMap[v.container_type].material || 'материал не указан') +
                '; ' +
                (v.state === 'filled' ? 'Заполняется; ' : 'Не заполняется;') +
                ')'
            }
          })
          commit('setMarkerLayersContainerPlatform', results)
          const mapData = {
            containerplatforms: [
              {
                id: results.id,
                name: results.addresses instanceof Array ? results.addresses[0] : '',
                isEditable: true,
                color: results.color,
                type: 'containerplatform',
                coordinates: results.point.coordinates.concat([]).reverse()
              }
            ]
          }
          commit(getters.markerLayersToEdit.type === 'containerplatform' ? 'updateMarkerLayersMap' : 'updateMarkerLayersPopupMap', mapData)
        }
      })
  },

  getMarkerLayerBuilding({ getters, commit, dispatch }, id) {
    return Vue.http
      .get(getters.endpoint.buildingById(id), {
        params: {
          [getters.objectsPeriod.scaleType.id]: getters.objectsPeriod.borders.join(','),
          workspace: getters.workspace,
          version: getters.version
        }
      })
      .then((r) => {
        if (r.data) {
          const results = r.data

          commit('setMarkerLayersBuilding', r.data)
          let buildings = []
          buildings = [
            {
              isEditable: true,
              type: 'building',
              name: results.address || 'Здание ' + id,
              coordinates: results.point.coordinates.concat([]).reverse()
            }
          ]

          if (getters.markerLayersToEdit.type === 'building') {
            commit('updateMarkerLayersMap', {
              buildings,
              containerplatforms: []
            })
          }
        }
      })
  },

  getMarkerLayerContainer({ getters, commit, dispatch }, id) {
    return Vue.http
      .get(getters.endpoint.containerById(id), {
        params: {
          workspace: getters.workspace,
          version: getters.version
        }
      })
      .then((r) => {
        commit('setMarkerLayersContainer', r.body)
        return r.body
      })
  },

  addMarkerLayerContainer({ getters, commit, dispatch }, params) {
    return Vue.http
      .post(getters.endpoint.container, params.params, {
        params: {
          workspace: getters.workspace,
          version: getters.version
        }
      })
      .then((r) => {
        const v = r.body
        const containersMap = getters.objectContainerTypes
        r.body.name =
          'Контейнер ' +
          v.id +
          ' (' +
          containersMap[v.container_type].volume +
          (containersMap[v.container_type].volume_designation || '') +
          '; ' +
          (containersMap[v.container_type].material || 'материал не указан') +
          '; ' +
          (v.state === 'filled' ? 'Заполняется; ' : 'Не заполняется;') +
          ')'
        commit('setMarkerLayersContainer', r.body)
        return r.body
      })
  },

  updateMarkerLayerContainer({ getters, commit, dispatch }, params) {
    return Vue.http
      .patch(getters.endpoint.containerById(params.id), params.params, {
        params: {
          workspace: getters.workspace,
          version: getters.version
        }
      })
      .then((r) => {
        const v = r.body
        const containersMap = getters.objectContainerTypes
        r.body.name =
          'Контейнер ' +
          v.id +
          ' (' +
          containersMap[v.container_type].volume +
          (containersMap[v.container_type].volume_designation || '') +
          '; ' +
          (containersMap[v.container_type].material || 'материал не указан') +
          '; ' +
          (v.state === 'filled' ? 'Заполняется; ' : 'Не заполняется;') +
          ')'
        commit('setMarkerLayersContainer', r.body)
        return r.body
      })
  },

  resetMarkerLayerPopupMap({ commit }) {
    this.commit('updateMarkerLayersPopupMap', {
      buildings: [],
      containerplatforms: []
    })
  },

  resetMarkerLayerMap({ commit }) {
    this.commit('updateMarkerLayersMap', {
      buildings: [],
      containerplatforms: []
    })
  },

  resetMarkerLayer({ commit }) {
    this.commit('setMarkerLayersEmitterCategories', [])
  }
}



// WEBPACK FOOTER //
// ./src/store/markerLayers/actions.js